import React from 'react';

import { Button, Dropdown, IconButton, Text } from 'shell/components';

const DropdownDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>Dropdown</Text>
            <Dropdown
                id={'dropdown-1'}
                align={'left'}
                options={[
                    { key: 'instructors', value: 'Add Instructors' },
                    { key: 'students', value: 'Add Students' },
                ]}
                rootComponent={<Button>Invite Members</Button>}
                onSelect={console.log}
            />
            <Dropdown
                id={'dropdown-2'}
                options={[
                    { key: 'edit', value: 'Edit' },
                    { key: 'duplicate', value: 'Duplicate' },
                    { key: 'delete', value: 'Delete' },
                ]}
                rootComponent={<IconButton kind={'moreHorizontal'} size={'small'} variant={'square'} />}
                onSelect={console.log}
            />
        </>
    );
};

export default DropdownDemo;
